import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DateAdapter, MatPaginator, MatSort, MatTableDataSource, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from 'app/contabilidad/nuevo-tipo-cambio/nuevo-tipo-cambio.component';
import { ReportesService } from 'app/services/reportes/reportes.service';
import { environment } from 'environments/environment';
import moment from 'moment';
import { exportJsonToExcel, servifinLabels } from 'app/shared/servifin-excel.export';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-rep-conciliacion',
  templateUrl: './rep-conciliacion.component.html',
  styleUrls: ['./rep-conciliacion.component.scss'],
  providers:[DatePipe,
    {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class RepConciliacionComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  labels = servifinLabels;
  date = new FormControl(moment());
  displayedColumns = ['Codigo_de_Valor','idContrato', 'idSolicitudDesembolso','serie', 'numero','Estado','RAZON_PROVEEDOR', 'RAZON_ADQUIRENTE', 'Moneda', 'VNPP', 'Adelanto_porcentaje', 'Plazo','Adelanto_Importe','Tasa_Mensual','Interes_Proveedor','IGV_Importe_Proveedor','Fecha_real_desembolso','Fecha_de_Pago','Serie2','Numero2'];
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  dataSource: any;
  dataEnviar:any=[]
  dataLista:any=[]
  loading:boolean;
  dataFiltro: FormGroup;
  fechaHop: Date = new Date();
  Codigo_de_Valor = new FormControl('');
  filterValues = {
    Codigo_de_Valor: '',
    };  
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private reporteService:ReportesService, private datePipe:DatePipe) {
    this.dataFiltro = new FormGroup({
      "Fecha_Inicio": new FormControl(this.datePipe.transform(moment().add(-120,'day'), 'yyyy-MM-dd')),
      "Fecha_Fin": new FormControl(this.datePipe.transform(Date(),'yyyy-MM-dd')),
      "Moneda":new FormControl(0)
    });
   }

  ngOnInit() {
    this.obtenerLista()

    this.Codigo_de_Valor.valueChanges
    .subscribe(
      Codigo_de_Valor => {
        this.filterValues.Codigo_de_Valor = Codigo_de_Valor;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )
  }

  createFilter(): (data: any, filter: string) => boolean {
    return function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return  data.Codigo_de_Valor.toString().toLowerCase().indexOf(searchTerms.Codigo_de_Valor) !== -1;
    }
  }

  tipoMoneda(event){
    if(event==''){
      this.dataFiltro.controls['Moneda'].setValue(0);
    }else{
      this.dataFiltro.controls['Moneda'].setValue(event);
    }  
  }

  ExportTOExcel() {
    exportJsonToExcel(this.dataLista, 'Sheet1', 'Reporte_Conciliacion_');
  }

  obtenerLista(){
    this.dataEnviar.Moneda=this.dataFiltro.controls['Moneda'].value
    this.dataEnviar.Desde=this.datePipe.transform(this.dataFiltro.controls['Fecha_Inicio'].value, 'yyyy-MM-dd')
    this.dataEnviar.Hasta=this.datePipe.transform(this.dataFiltro.controls['Fecha_Fin'].value, 'yyyy-MM-dd')
    this.loading=true;
    this.reporteService.ObtenerConciliaciones(this.dataEnviar).subscribe(
      res => {
        this.dataLista = res;
        this.dataSource = new MatTableDataSource(this.dataLista);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = this.createFilter();
        this.loading = false;
      },err =>{
          Swal.fire({
            title: "¡Algo salió mal!",
            text:  err.error['error'],
            type: "warning",
            allowOutsideClick: true,
            heightAuto: false
          });        
          this.loading = false;
      }
    )
  }

}
